angular
.module('inkfinder')
.factory('Artists', function Artists(
  $q,
  $http,
  $rootScope,
  $interval,
  ENDPOINT,
  StatsFactory,
  Association,
  moment,
  Session,
  AlertMessages,
  _
) {
  Artists.fetchArtists = fetchArtists;
  Artists.refreshArtists = refreshArtists;
  Artists.createArtist = createArtist;

  let qwe; // The object holding all variables relating to queries
  resetVariables();

  /**
   * @name resetVariables
   * @description description
   */
  function resetVariables() {
    qwe = {
      artists: {}
    };
    Artists.artists = [];
  }

/**
  * Create an artist
  * @param {input} input The artist object to create
  * @return {object} Returns a promise object containing the arist
  */
  function createArtist(input) {
    return $http.post(ENDPOINT.server + 'artists/api/v1.1/', input)
      .then(function(response) {
        return response.data;
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        throw error;
      });
  }

  // Called to Reset Data on Logout
  let deregister = $rootScope.$on('clear-data', function() {
    $interval.cancel(qwe.artists.timer);
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
   * @name createArtistTimer
   * @description description
   */
  function createArtistTimer() {
    if (!qwe.artists.timer) {
      qwe.artists.timer = $interval(makeNewArtistPromise, 1000);
    }
  }

  /**
   * @name makeNewArtistPromise
   * @description description
   */
  function makeNewArtistPromise() {
    if (!shouldRefresh()) {
      return;
    }

    qwe.artists.promise = $q(function(resolve, reject) {
      qwe.artists.refreshing = true;
      let shopId = Session.activeState.association.shop.id;
      Association.getShopAssociations(shopId, Session.activeState.role, 'artist')
      .then(function(collectors) {
        Artists.artists = collectors.artists;

        if (qwe.artists.timer) {
          _.each(Artists.artists.confirmed, function(artist) {
            artist.stats = StatsFactory.getArtistStats(artist.id);
          });
          qwe.artists.updated = moment();
        }
        qwe.artists.refreshing = false;
        resolve(Artists.artists);
      }, function() {
        reject();
      });
    });
  }

  /**
   * @name shouldRefresh
   * @description description
   * @return {type} Description
   */
  function shouldRefresh() {
    return !qwe.artists.refreshing && (!qwe.artists.updated ||
    moment().diff(qwe.artists.updated, 'seconds') >= 79);
  }

  /**
   * @name fetchArtists
   * @description description
   * @return {type} Description
   */
  function fetchArtists() {
    createArtistTimer();
    makeNewArtistPromise();
    return qwe.artists.promise;
  }

  /**
   * @name refreshArtists
   * @description description
   * @return {type} Description
   */
  function refreshArtists() {
    qwe.artists.updated = null;
    return fetchArtists();
  }

  return Artists;
});



// WEBPACK FOOTER //
// ./components/artists/artists.service.js